import Call from './container';

export default Call;



// WEBPACK FOOTER //
// ./src/routes/Call/index.js